import React from 'react';
type AcroStackProps = {
  className?: string;
  title?: string;
};
const NIGHT = '#1E2140';
const CORAL = '#F2694B';
const SAFFRON = '#F2B33D';
const MOSS = '#7FAE5A';
const SAND = '#F6EFE4';
const PANEL = '#EDE3D3';

/**
 * Diagrama de figuras del producto (leyenda de los tomos): Base en Night
 * Indigo en L-base, Flyer en Sunrise Coral en front bird, Spotter con
 * contorno Saffron, línea de apilado óseo punteada, puntos de contacto y
 * flecha Moss de salida. Va siempre sobre fondo claro.
 */
export function AcroStack({
  className,
  title = 'Base, flyer and spotter in front bird'
}: AcroStackProps) {
  return <svg viewBox="0 0 260 200" role="img" aria-label={title} className={className} data-id="element-22" data-mp="3k66ob4di6i77">
      {/* colchoneta */}
      <rect x="10" y="183" width="240" height="9" rx="4.5" fill={PANEL} data-id="element-23" data-mp="3p2x55tx4thto" />

      {/* línea de apilado óseo */}
      <line x1="118" y1="46" x2="118" y2="184" stroke={NIGHT} strokeOpacity="0.45" strokeWidth="2" strokeDasharray="3 5" strokeLinecap="round" data-id="element-24" data-mp="3u4w9b60p4iro" />

      {/* flecha de salida segura */}
      <path d="M156 104 C 168 124, 174 146, 174 168" fill="none" stroke={MOSS} strokeWidth="4" strokeLinecap="round" data-id="element-25" data-mp="c6lvgtl1fq7z" />
      <path d="M167 162 L174 175 L181 162" fill="none" stroke={MOSS} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-26" data-mp="75g0ep3wnqva" />

      {/* BASE */}
      <circle cx="34" cy="170" r="12" fill={NIGHT} data-id="element-27" data-mp="3teh84uienvti" />
      <line x1="52" y1="172" x2="112" y2="172" stroke={NIGHT} strokeWidth="20" strokeLinecap="round" data-id="element-28" data-mp="3tfsg76ivvpqf" />
      <line x1="117" y1="166" x2="118" y2="100" stroke={NIGHT} strokeWidth="15" strokeLinecap="round" data-id="element-29" data-mp="uyenolsa97en" />
      <line x1="58" y1="163" x2="70" y2="114" stroke={NIGHT} strokeWidth="9" strokeLinecap="round" data-id="element-30" data-mp="pzbsdt23ufjv" />

      {/* FLYER */}
      <circle cx="68" cy="82" r="11" fill={CORAL} data-id="element-31" data-mp="g7pajdv9hi85" />
      <line x1="86" y1="84" x2="148" y2="84" stroke={CORAL} strokeWidth="18" strokeLinecap="round" data-id="element-32" data-mp="g6wbz06ghz13" />
      <line x1="150" y1="84" x2="196" y2="78" stroke={CORAL} strokeWidth="12" strokeLinecap="round" data-id="element-33" data-mp="1doe7at5ctuao" />
      <line x1="82" y1="92" x2="72" y2="110" stroke={CORAL} strokeWidth="8" strokeLinecap="round" data-id="element-34" data-mp="18ujpjv9b7pe8" />

      {/* SPOTTER (contorno) */}
      <circle cx="224" cy="72" r="10" fill={SAND} stroke={SAFFRON} strokeWidth="4" data-id="element-35" data-mp="3831v2enxnilw" />
      <line x1="224" y1="90" x2="224" y2="138" stroke={SAFFRON} strokeWidth="16" strokeLinecap="round" data-id="element-36" data-mp="3854mn34qhjsq" />
      <line x1="224" y1="90" x2="224" y2="138" stroke={SAND} strokeWidth="8" strokeLinecap="round" data-id="element-37" data-mp="2tcb2h4eiofhq" />
      <line x1="222" y1="142" x2="212" y2="180" stroke={SAFFRON} strokeWidth="11" strokeLinecap="round" data-id="element-38" data-mp="2yavuigjm7sv3" />
      <line x1="222" y1="142" x2="212" y2="180" stroke={SAND} strokeWidth="4" strokeLinecap="round" data-id="element-39" data-mp="2of2lv890ojil" />
      <line x1="226" y1="142" x2="236" y2="180" stroke={SAFFRON} strokeWidth="11" strokeLinecap="round" data-id="element-40" data-mp="2af9nqrv5v10l" />
      <line x1="226" y1="142" x2="236" y2="180" stroke={SAND} strokeWidth="4" strokeLinecap="round" data-id="element-41" data-mp="2fe4ceaft7jsm" />
      <line x1="220" y1="100" x2="200" y2="92" stroke={SAFFRON} strokeWidth="9" strokeLinecap="round" data-id="element-42" data-mp="8o6b5x1pncde" />
      <line x1="220" y1="100" x2="200" y2="92" stroke={SAND} strokeWidth="3" strokeLinecap="round" data-id="element-43" data-mp="dnj85amapztp" />

      {/* puntos de contacto */}
      <circle cx="118" cy="95" r="4.5" fill="#FFFFFF" stroke={NIGHT} strokeWidth="2" data-id="element-44" data-mp="1y5tmmpwuj1p2" />
      <circle cx="71" cy="112" r="4.5" fill="#FFFFFF" stroke={NIGHT} strokeWidth="2" data-id="element-45" data-mp="1t709wzpdvepy" />

      {/* etiquetas B / F / S */}
      <g fontFamily="Outfit, system-ui, sans-serif" fontSize="10" fontWeight="800" textAnchor="middle" dominantBaseline="central" data-id="element-46" data-mp="27wenyl3wmkbo">
        <circle cx="86" cy="146" r="9" fill={NIGHT} data-id="element-47" data-mp="2gvjjrjo2zzk5" />
        <text x="86" y="146.5" fill="#FFFFFF" data-id="element-48" data-mp="2gu8dnd75yfpv">B</text>
        <circle cx="98" cy="56" r="9" fill={CORAL} data-id="element-49" data-mp="2bwp1qjxxuf13" />
        <text x="98" y="56.5" fill={NIGHT} data-id="element-50" data-mp="2bvx3f1cyi374">F</text>
        <circle cx="246" cy="52" r="9" fill="#FFFFFF" stroke={SAFFRON} strokeWidth="2.5" data-id="element-51" data-mp="2qtfvackxkwis" />
        <text x="246" y="52.5" fill={NIGHT} data-id="element-52" data-mp="2luw4nyve6wk3">S</text>
      </g>
    </svg>;
}